<template>
<div class="main">
    <iframe
        style="position: absolute; top: 0; left: 0; bottom: 0; right: 0;"
        id="iframe"
        width="100vw"
        height="100vh"
        :src="src"
        frameborder="0"
    ></iframe>
</div>
</template>

<script>
export default {
    name: 'Video',
    data() {
        return {
            src: '',
            show: false
        }
    },
    mounted() {
        let iframe = document.getElementById('iframe')
        iframe.height = window.innerHeight + "px";
        iframe.width = window.innerWidth + "px";
        this.src = this.$route.query.src
        //this.init()
    },
    methods: {
    },

}
</script>

<style lang="less" scoped>
.main {
    width: 100vw;
    height: 100vh;
    background: #fff;
    overflow: hidden;
}

.main iframe {
    width: 100vw;
    height: 100vh;
}
</style>
